import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50f7f041&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=50f7f041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7f041",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f7f041')) {
      api.createRecord('50f7f041', component.options)
    } else {
      api.reload('50f7f041', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50f7f041&scoped=true&", function () {
      api.rerender('50f7f041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/RecentJobs/index.vue"
export default component.exports